import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { buttonConfigs } from '@/components/custom/arito/custom-input-table/components/action-button-set';
import { AritoIcon, ButtonType } from '@/components/custom/arito';
import { useAuth } from '@/contexts/auth-context';

interface ButtonConfig {
  type: ButtonType;
  onClick: () => void;
  disabled?: boolean;
  title?: string;
  icon?: number;
}

interface ActionBarProps {
  handlePin?: () => void;
  handleDeleteRow: () => void;
}

const renderActionButton = (button: ButtonConfig, loading: boolean): React.ReactNode => {
  let icon: number;
  let title: string;

  if (button.icon !== undefined && button.title) {
    icon = button.icon;
    title = button.title;
  } else {
    const config = buttonConfigs[button.type] || { icon: 0, title: '' };
    icon = config.icon;
    title = config.title;
  }

  const isDisabled = button.disabled || loading || false;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span>
            <button
              className='flex items-center gap-1 rounded-md text-sm hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50'
              onClick={button.onClick}
              disabled={isDisabled}
              type='button'
            >
              <AritoIcon icon={icon} className='' /> {<span>{button.type === 'delete' ? 'Xoá' : 'Cố định cột'}</span>}
            </button>
          </span>
        </TooltipTrigger>
        <TooltipContent>{title}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default function ActionBar({ handlePin, handleDeleteRow }: ActionBarProps) {
  const buttonActions = {
    pin: handlePin,
    delete: handleDeleteRow
  } as Record<ButtonType, () => void | undefined>;

  const buttonTypes: ButtonType[] = (['delete', 'pin'] as ButtonType[]).filter(
    type => buttonActions[type] !== undefined
  );

  const buttons: ButtonConfig[] = buttonTypes.map(type => ({
    type,
    onClick: buttonActions[type],
    disabled: false
  }));
  const { loading } = useAuth();
  return (
    <div className='flex h-9 flex-none items-center justify-between border-b border-gray-200 bg-white px-1 py-0'>
      <div className='flex h-full flex-1 items-center justify-between'>
        <div className='flex items-center gap-3'>
          {buttons.map((button, index) => (
            <span key={button.type + index}>{renderActionButton(button, loading)}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
